export default class GraphService {
    constructor() {
        this.graphUrl = 'https://graph.microsoft.com/v1.0/me/events';
    }

    getUserInfo(token, data) {
        let request = new Request(this.graphUrl, {
            method: "POST",
            body: JSON.stringify(data),
            headers: new Headers({
								Authorization: `Bearer ${token}`,
								'Content-Type': 'application/json'
            })
        });
        return fetch(request)
            .then(response => response.json())
            .catch(response => {
                throw new Error(response.text());
            });
    };
}
